export const AuthConfig = {
  jwtCookieName: 'ci_jwt_api2'
};
